import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import isEmpty from 'lodash/isEmpty';
import Fuse from "fuse.js";
import {toast} from "../../../store/toaster/actions";
import styled from "styled-components";
import {getCurrencies} from "./store/actions";
import {InputGroup, NonIdealState, Spinner, Button} from "@blueprintjs/core";
import {AutoSizer, Column, Table} from "react-virtualized";
import Editor from "./editor";
import {toggleCurrencyEditor} from './store/actions';


const StyledList = styled.div`
  height: 100%;
  width: 100%;
  padding: 8px 16px;
`;

const FUSE_OPTIONS = {
  threshold: 0.5,
  maxPatternLength: 32,
  minMatchCharLength: 2,
  keys: [
    {name: 'name', weight: 0.4},
  ]
};

class SettingsCurrencies extends Component {
  state = {
    search: '',
    record: parseInt(this.props.match.params._id),
  }

  componentDidMount() {
    this.props.getCurrencies();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (!isEmpty(nextProps.data)) {
      nextProps.getCurrencies();
    }
  }

  render() {
    const { records, loading, toggleCurrencyEditor } = this.props;
    const fuse = new Fuse(records, FUSE_OPTIONS);
    const filteredRecords = this.state.search.length ? fuse.search(this.state.search) : records;
    console.log(filteredRecords)


    return (
      <React.Fragment>
        {loading ? (
          <Spinner className="mt50" />
        ) : (
          <React.Fragment>
            <div className="tools">
              <Button large onClick={() => toggleCurrencyEditor({})} icon="add" intent="success" text="Add New" />
              <div className="flex">
                <InputGroup
                  leftIcon="search"
                  onChange={(e) => {
                    this.setState({
                      search: e.currentTarget.value
                    })
                  }}
                  large
                  placeholder="Search"
                />
              </div>
            </div>
            {filteredRecords.length > 0 ? (
              <StyledList>
                <AutoSizer>
                  {({width, height}) => (
                    <Table
                      ref="Table"
                      headerHeight={30}
                      noRowsRenderer={this._noRowsRenderer}
                      overscanRowCount={10}
                      rowClassName={this._rowClassName}
                      rowHeight={30}
                      rowCount={filteredRecords.length}
                      rowGetter={({ index }) => filteredRecords[index]}
                      height={height}
                      onRowClick={(event) => toggleCurrencyEditor(event.rowData)}
                      width={width}>
                      <Column
                        label='Name'
                        dataKey='name'
                        width={width * 0.4}
                      />
                      <Column
                        label='Code'
                        dataKey='code'
                        width={width * 0.3}
                      />
                      <Column
                        label='Rate'
                        dataKey='rate'
                        width={width * 0.3}
                      />                      
                    </Table>
                  )}
                </AutoSizer>
              </StyledList>
            ) : (
              <NonIdealState
                icon="search"
                title="No currency found"
              />
            )}
          </React.Fragment>
        )}
        <Editor />
      </React.Fragment>
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    toast,
    getCurrencies,
    toggleCurrencyEditor,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    loading: state.settingsCurrencies.loading,
    records: state.settingsCurrencies.data,
  }
}

export default (connect(mapStateToProps, matchDispatchToProps)(SettingsCurrencies));
